import {AfterViewInit, ChangeDetectorRef, Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {SchoolingParticipant, SchoolingParticipantDetails} from '@shared/models/schooling-participant.model';
import {SchoolingParticipantService} from '@shared/services/schooling-participant.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {TranslationService} from '@shared/services/translation.service';
import {checkPageSize, DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS, pageChange} from '@shared/utils/utils';
import {merge} from 'rxjs';
import {filter, tap} from 'rxjs/operators';
import {EmployeeDialogComponent} from '@shared/components/employee-dialog/employee-dialog.component';
import {ConfirmDialogComponent, ConfirmDialogConfig} from '@shared/components/confirm-dialog/confirm-dialog.component';
import {SchoolingPlanStatusModel} from '@shared/models/schooling-plan.model';
import {Topic} from '@shared/models/topic.model';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import {SchoolingTuitionService} from '@shared/services/schooling-tuition.service';
import {SchoolingTuition} from '@shared/models/schooling-tuition.model';


export interface SchoolingTuitionParticipantsConfig {
  multiple: boolean;
  selected: Topic[];
  topicId: number;
  tuitionId: number;
  employeeIds: [];
  assigneeEmployeeId: number;
}

@Component({
    selector: 'saf-schooling-tuition-participants-dialogs',
    templateUrl: './schooling-tuition-participants-dialogs.component.html',
    styleUrls: ['./schooling-tuition-participants-dialogs.component.scss'],
    standalone: false
})
export class SchoolingTuitionParticipantsDialogsComponent implements OnInit, AfterViewInit {
  public tuitionId: number;
  @Input() public topicId: number;
  @Input() public tuitionStatus: number;
  @Input() public acceptMember: boolean;
  @Input() public assigneeEmployeeId: number;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  public tableColumns = ['select', 'employeeNumber', 'firstName',  'lastName', 'status'];
  public dataSource = new MatTableDataSource<SchoolingParticipantDetails>();
  public participantDetails: SchoolingParticipantDetails [];
  public participantDetailsAll: SchoolingParticipantDetails [];
  public totalCount = 0;
  public drawerFilterParams: any = {};
  public searchFilterParams: any = {};
  private participantsIds: number [] = [];
  private employeeIds: number [] = [];
  public loading: boolean = false;
  public trackById = (item) => item.id;

  constructor(
    private participantService: SchoolingParticipantService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private translationService: TranslationService,
    private changeDetectorRef: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    @Inject(PAGE_SIZE_OPTIONS) public pageSizeOptions,
    @Inject(DEFAULT_PAGE_SIZE) public pageSize,
    @Inject(MAT_DIALOG_DATA) public config: SchoolingTuitionParticipantsConfig,
    public dialogRef: MatDialogRef<SchoolingTuitionParticipantsDialogsComponent>,
    private schoolingTuitionService: SchoolingTuitionService,

  ) { }

  ngOnInit(): void {
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    merge(this.sort.sortChange, this.paginator.page).subscribe(() => this.loadTable());
  }

  ngAfterViewInit() {
    this.loadTable();
    // this.changeDetectorRef.detectChanges();
  }

  loadTable() {
    const params = {
      filter: {
        ...this.searchFilterParams,
        ...this.drawerFilterParams,
        tuitionId: this.config.tuitionId
      },
      sort: this.sort.direction ? this.sort.active : '',
      dir: this.sort.direction,
      start: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
    };

    this.loading = true;

    this.participantService.getListDetails(params)
      .pipe(tap(() => this.loading = false))
      .subscribe(result => {
        this.totalCount = result.total;
        this.dataSource.data = result.data;
        this.participantDetailsAll = result.data;
        this.participantDetails = [];
      });
  }


  openDialog() {
    const dialogConfig: MatDialogConfig = {
      panelClass: 'table-dialog',
      disableClose: false,
      data: {
        multiple: true,
        showInactive: false,
        showAll: true,
        hideEmployeesWithoutAssignment: false
      }
    };

    this.dialog.open(EmployeeDialogComponent, dialogConfig)
      .afterClosed()
      .pipe(filter((success) => success))
      .subscribe((result) => {
        const params = {
          employeeIds: result,
          tuitionId: this.tuitionId,
          status: 1,
          assigneeEmployeeId: this.assigneeEmployeeId,
          // need this for backend participants overwrite online schooling
          overwrite: true
        };

        this.loading = true;

        if (result) {
          this.participantService.createMultiple(params)
            .pipe(tap(() => this.loading = false))
            .subscribe(() => {
              this.loadTable();
            });
        }
      });
  }

  openDeleteDialog(e, item: SchoolingParticipant) {
    e.stopPropagation();
    if (this.tuitionStatus === 1) {
      this.snackBar.open(this.translationService.translate('notDeletable'));
      return;
    }
    const data = new ConfirmDialogConfig({
      title: this.translationService.translate('confirmDeleteTitle'),
      message: this.translationService.translate('confirmDeleteParticipant'),
      confirmText: this.translationService.translate('confirm'),
    });

    this.dialog.open(ConfirmDialogComponent, {data})
      .afterClosed()
      .pipe(filter((confirmed) => confirmed))
      .subscribe(() => {
        this.loading = true;
        this.participantService.delete(item.id)
          .subscribe((result) => {
            result.success ? this.reloadTable() : this.snackbar.open(this.translationService.translate('notDeletable'));
            this.loading = false;
          });
      });
  }

  reloadTable() {
    SchoolingParticipantService.clearCache();
    this.loadTable();
  }

  applyDrawerFilters(filterParams) {
    this.drawerFilterParams = filterParams;
    this.paginator.pageIndex = 0;
    this.loadTable();
  }
  checkIfStandard(listItem: SchoolingPlanStatusModel) {
    if (listItem.employee) {
      return true;
    }

    return false;
  }

  protected readonly pageChange = pageChange;
  protected readonly checkPageSize = checkPageSize;

  closeDialog(e) {
    this.dialogRef.close(false);
  }

  selectParticipant(participant: SchoolingParticipantDetails, event: MatSlideToggleChange) {

    if (event.checked) {
      this.participantDetails = this.participantDetails.filter(
        (participantDetail) => participantDetail.employee.id !== participant.employee.id
      );
      if (!this.participantDetailsAll.some((participantDetail) => participantDetail.employee.id === participant.employee.id)) {
        this.participantDetailsAll.push(participant);
      }
    } else {
      if (!this.participantDetails.some((participantDetail) => participantDetail.employee.id === participant.employee.id)) {
        this.participantDetails.push(participant);
      }
      this.participantDetailsAll = this.participantDetailsAll.filter(
        (participantDetail) => participantDetail.employee.id !== participant.employee.id
      );
    }

  }

  submit() {
    this.participantDetails.forEach(participant => {
      this.participantsIds.push(participant.participant.id);
      this.employeeIds.push(participant.participant.employeeId);
    });
    const data = {
      participantIds: this.participantsIds
    };
    if(this.participantDetails.length > 0) {
      this.participantService.deleteMultiple(data)
        .pipe()
        .subscribe((result) => {
          this.createNewDate();
        });
    } else {
      this.dialogRef.close(true);
    }

  }

  createNewDate () {
    const data = new ConfirmDialogConfig({
      title: this.translationService.translate('createNewDate'),
      message: this.translationService.translate('createNewDateInfo'),
      confirmText: this.translationService.translate('confirm'),
    });

    this.dialog.open(ConfirmDialogComponent, {data})
      .afterClosed()
      .subscribe((confirmed) => {
        if(confirmed) {
          this.loading = true;
          const params = {
            topicId: this.config.topicId,
            assigneeEmployeeId: this.config.assigneeEmployeeId,
            tuitionDate: ''
          };
          this.schoolingTuitionService.create(params)
            .pipe()
            .subscribe((result) => {
              this.addParticipants(result.data);
            });
        } else {
          this.dialogRef.close(true);
        }

      }
      );
  }


  addParticipants (tuitionData: SchoolingTuition) {

    const params = {
      employeeIds: this.employeeIds,
      tuitionId: tuitionData.id,
      status: 1,
      assigneeEmployeeId: this.config.assigneeEmployeeId,
      // need this for backend participants overwrite online schooling
      overwrite: true
    };

    this.loading = true;

    this.participantService.createMultiple(params)
      .pipe(tap(() => this.loading = false))
      .subscribe((result) => {
        this.snackBar.open(this.translationService.translate('newTuitionSuccess'));
        this.dialogRef.close(true);
      });
  }

  toggleAll(event: MatSlideToggleChange) {
    if (event.checked) {
      this.participantDetailsAll = this.dataSource.data;
      this.participantDetails = [];
    } else {
      this.participantDetails = this.dataSource.data;
      this.participantDetailsAll = [];
    }
  }

  isAllSelected() {

    if(this.participantDetailsAll) {
      return this.participantDetailsAll.length === this.dataSource.data.length;
    } else {
      return false;
    }
  }

  checked(participant: SchoolingParticipantDetails) {
    if(this.participantDetailsAll) {
      return this.participantDetailsAll.some((participantDetail) => {
        return participantDetail.employee.id === participant.employee.id;
      });
    } else {
      return false;
    }
  }
}
